import SelfPay from 'src/app/models/selfPay';
import { faCalendar, faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import { ControlContainer, NgForm } from '@angular/forms';
import { Component, ViewEncapsulation, Input, OnInit, OnChanges, Output, EventEmitter, ViewChild } from '@angular/core';
import { filter, cloneDeep } from 'lodash';
import SelfPayFormSpouse from 'src/app/models/selfPayFormSpouse';
import SelfPayFormDependent from 'src/app/models/selfPayFormDependent';
import SelfPayType from 'src/app/models/selfPayType';
import { env } from 'src/env/development';
import * as dayjs from 'dayjs';

@Component({
  selector: 'self-pay-add-spouse',
  templateUrl: 'selfPay.addSpouse.component.html',
  styleUrls: [],
  providers: [],
  encapsulation: ViewEncapsulation.None,
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class SelfPayAddSpouseComponent implements OnChanges, OnInit {
  @Input() selfPaySpouse: SelfPayFormDependent;
  @Input() pebbVisionDate: Date;
  @Input() idx: number;
  @Input() requestType: SelfPayType;
  @Input() selfPay: SelfPay;
  @Input() agency: string;
  @Output() submitDependent: EventEmitter<SelfPayFormDependent> = new EventEmitter<SelfPayFormDependent>();
  @Output() closePanel: EventEmitter<void> = new EventEmitter<void>();
  currentMaxDate: Date;
  currentSpouse: SelfPayFormDependent;
  electMedicalDisabled = false;
  electDentalDisabled = false;
  icons = {
      faCalendar,
      faExclamationCircle
  };
  env = env;
  isCobra: boolean = false;
  isPebbLwopVision: boolean = false;
  isPebbRetireeVision: boolean = false;
  isPebbCobraInitial: boolean = false;
  isPebbCobraSOE: boolean = false;
  isCobraOE: boolean = false;
  isSebbCobra: boolean = false;
  thirteenYearsDate: Date;
  disableFormForNoCoverage = false;
  coverageYear: number;
  otherAgency: string;
  isPebbVisionEnabled = false;
  
  ngOnInit(): void {
    this.thirteenYearsDate = dayjs().subtract(13, 'year').toDate();
    this.currentMaxDate = new Date();
    this.isPebbVisionEnabled = this.selfPay?.coverageEffectiveDate ? dayjs(this.selfPay?.coverageEffectiveDate).isSameOrAfter(this.pebbVisionDate) : dayjs(new Date()).isSameOrAfter(this.pebbVisionDate);

    this.isPebbLwopVision = this.agency === 'PEBB' && (((this.requestType.selfPayTypeCode === 'ALWOP' || this.requestType.selfPayTypeCode === 'SOEU') &&  this.isPebbVisionEnabled) || this.requestType.selfPayTypeCode === "OEU");
    this.isSebbCobra = this.selfPay.isSEBB && this.selfPay.isCOBRA;
    this.coverageYear = dayjs(this.selfPay.coverageEffectiveDate ?? new Date()).year();
    this.otherAgency = this.selfPay.isSEBB ? env.pebbCode : env.sebbCode;

    if (this.selfPay.isPEBB && (this.selfPay.isCobraInitial || this.selfPay.isCobraSOE)) {
      if (this.selfPay.formJson.subscriber.medicarePartBInd)
        this.currentSpouse.surchargeNA = true;
    }
  }

  ngOnChanges() {
    this.isCobra = env.cobraSelfPayTypeCodes.includes(this.requestType.selfPayTypeCode);
    if (this.selfPaySpouse) {
      this.currentSpouse = cloneDeep(this.selfPaySpouse);
    }
    if (this.requestType.selfPayTypeCode === 'R'  || this.requestType.selfPayTypeCode === 'OER') {
      this.electMedicalDisabled = true;
      this.electDentalDisabled = true;
      if(this.selfPay?.formJson?.subscriber?.medicalEnrollInd || this.selfPay?.formJson?.subscriber?.dentalEnrollInd && !this.isPebbRetireeVision && !this.isCobraOE) {
        //dental enrolled means both dental and medical now
        this.currentSpouse.medicalCoverInd = true;
      }
      if(this.selfPay?.formJson?.subscriber?.dentalEnrollInd && !this.isPebbRetireeVision && !this.isCobraOE) {
        this.currentSpouse.dentalCoverInd = true;
      }

      if (this.requestType.selfPayTypeCode === 'R' && this.selfPay.formJson?.subscriber?.actionsCode === 'deferring' &&
          this.selfPay.formJson?.subscriber?.deferQuestionFour) {
          //initial retiree request is deferring due to medicaid, enable dependent coverage for medical only
          this.electMedicalDisabled = false;
          this.electDentalDisabled = true;
      }
    }
    this.isPebbLwopVision = this.agency === 'PEBB' && (((this.requestType.selfPayTypeCode === 'ALWOP' || this.requestType.selfPayTypeCode === 'SOEU')  &&  this.selfPay?.coverageEffectiveDate ? dayjs(this.selfPay?.coverageEffectiveDate).isSameOrAfter(this.pebbVisionDate) : dayjs(new Date()).isSameOrAfter(this.pebbVisionDate)) || this.requestType.selfPayTypeCode === "OEU");
    this.isPebbRetireeVision = this.agency === 'PEBB' && ((this.requestType.selfPayTypeCode === 'R' &&  (this.selfPay?.coverageEffectiveDate ? dayjs(this.selfPay?.coverageEffectiveDate).isSameOrAfter(this.pebbVisionDate) : dayjs(new Date()).isSameOrAfter(this.pebbVisionDate))) || this.requestType.selfPayTypeCode === "OER");
    this.isCobraOE = this.requestType.selfPayTypeCode === "OEC";
    this.isPebbCobraInitial = this.selfPay.isPEBB && this.selfPay.isCobraInitial;
    this.isPebbCobraSOE = this.selfPay.isPEBB && this.selfPay.isCobraSOE;
    this.isSebbCobra = this.selfPay.isSEBB && this.selfPay.isCOBRA;
    if(this.isPebbRetireeVision){
      this.disableFormForNoCoverage = !this.currentSpouse.medicalCoverInd && !this.currentSpouse.dentalCoverInd && !this.currentSpouse.visionCoverInd
    }
  }

  emitSubmitDependent() {
    this.submitDependent.emit(this.currentSpouse);
  }

  cancelChanges() {
    this.currentSpouse = cloneDeep(this.selfPaySpouse);
    this.closePanel.emit();
  }

  updateTobacco() {
    if (this.currentSpouse.surchargeNA) {
      this.currentSpouse.tobaccoUseInd = null;
      this.currentSpouse.spouseForm.spouseSurchargeTriState = "N";
      this.currentSpouse.spouseForm.questionTwoInd = false;
      this.currentSpouse.spouseForm.questionThreeInd = false;
      this.currentSpouse.spouseForm.questionFourInd = false;
      this.currentSpouse.spouseForm.questionFiveInd = false;
      this.currentSpouse.spouseForm.questionSixInd = false;
    }
  }

  spousalChange(spouse: SelfPayFormDependent): void {
    if (!(this.selfPay.isPEBB && this.selfPay.isRetireeSOE))
      return;

    if (spouse.spouseAttestQ1 && spouse.spouseAttestQ2 && spouse.spouseAttestQ3 && spouse.spouseAttestQ4 && spouse.spouseAttestQ5 && spouse.spouseAttestQ6)
      this.currentSpouse.spouseSurchargeTriState = 'Y';
    else if (spouse.spouseAttestQ1 === false || spouse.spouseAttestQ2 === false || spouse.spouseAttestQ3 === false || spouse.spouseAttestQ4 === false || spouse.spouseAttestQ5 === false || spouse.spouseAttestQ6 === false)
      this.currentSpouse.spouseSurchargeTriState = 'N';
  }

  updateMedicarePartA(yes: boolean) {
    if(!yes) {
      this.currentSpouse.medicarePartADate = null;
      this.currentSpouse.medicarePartAInd = false;
    }
    if(yes) {
      this.currentSpouse.medicarePartAInd = true;
    }
  }

  updateMedicarePartB(yes: boolean) {
    if(!yes) {
      this.currentSpouse.medicarePartBDate = null;
      this.currentSpouse.medicarePartBInd = false;
    }
    if(yes) {
      if (!this.isSebbCobra) this.currentSpouse.visionCoverInd = false;
      this.currentSpouse.medicarePartBInd = true;
    }
  }

  handleCoverageChange(e) {
    if(e) {
      this.disableFormForNoCoverage = false;
    }else if(!this.currentSpouse.medicalCoverInd && !this.currentSpouse.dentalCoverInd && !this.currentSpouse.visionCoverInd) {
      this.disableFormForNoCoverage = true;
      this.resetFormValues();
    }
  }

  resetFormValues() {
    this.currentSpouse.medicarePartAInd =
    this.currentSpouse.medicarePartBInd =
    this.currentSpouse.spouseSurchargeTriState =
    this.currentSpouse.spouseAttestQ1 =
    this.currentSpouse.spouseAttestQ2 =
    this.currentSpouse.spouseAttestQ3 =
    this.currentSpouse.spouseAttestQ4 =
    this.currentSpouse.spouseAttestQ5 =
    this.currentSpouse.spouseAttestQ6 =
    this.currentSpouse.medicareNumber =
    this.currentSpouse.medicarePartADate =
    this.currentSpouse.medicarePartBDate =
    this.currentSpouse.tobaccoUseInd = null
  }

}
